module.exports = __webpack_public_path__ + "img/hand-right.150b8dd1.png";